import Slider from "@mui/material/Slider";
import { Box, Typography } from "@mui/material";
import InputField from "./InputField";
import ISliderRadiusProps from "../../interfaces/ISliderRadiusProps";

export const SliderRadius: React.FC<ISliderRadiusProps & { isEditable?: boolean }> = ({
  value,
  min,
  max,
  step,
  onChange,
  color,
  isEditable = true,
}) => {
  return (
    <Box display="flex" justifyContent="space-between" gap={2} alignItems="center">
      <Typography fontSize={10}>Radius</Typography>

      <Slider
        value={value}
        min={min}
        max={max}
        step={step}
        disabled={!isEditable}
        valueLabelDisplay="auto"
        valueLabelFormat={(v) => `${v} miles`}
        onChange={(_, newValue) => onChange(newValue as number)}
        sx={{
          opacity: isEditable ? 1 : 0.6,
          transition: "opacity 0.3s",
          color,
          height: 2,

          "& .MuiSlider-thumb": {
            width: 10,
            height: 10,
            backgroundColor: "var(--fx-surface-base, #FFFFFF)",
            border: `2px solid ${color}`,
            "&:hover, &.Mui-focusVisible, &.Mui-active": {
              boxShadow: "none",
            },
          },

          "& .MuiSlider-track": {
            border: "none",
          },

          "& .MuiSlider-rail": {
            opacity: 0.3,
            backgroundColor: "black",
          },

          "& .MuiSlider-valueLabel": {
            fontSize: 10,
          },
        }}
      />

      <InputField
        type="text"
        value={value}
        extraType="miles"
        onChange={(val) => {
          const num = Number(val);
          if (!isNaN(num) && num >= 0) {
            onChange(num);
          }
        }}
      />
    </Box>
  );
};

export default SliderRadius;
